module.exports = __webpack_public_path__ + "static/media/hci.768cca3a.svg";